import formatLocaleNumber from "~/helpers/localeNumberFormat";
import i18n from "~/i18n/i18n";

// Mirrors WsapiAiOrchestrator.Api.Shared.Constants.MaxAttachedContextLength.
const MAX_ATTACHED_CONTEXT_LENGTH = 50_000;

const isAttachedContextTooLong = (attachedContext: string | null): boolean =>
	(attachedContext?.length ?? 0) > MAX_ATTACHED_CONTEXT_LENGTH;

const buildAttachedContextTooLargeMessage = (fileName: string | null, includesScreen: boolean): string => {
	const limit = formatLocaleNumber(MAX_ATTACHED_CONTEXT_LENGTH);
	if (!fileName) return i18n.t("fernieChat.contextTooLarge", { limit, ns: "common" });
	return includesScreen
		? i18n.t("fernieChat.attachmentWithScreenTooLarge", { fileName, limit, ns: "common" })
		: i18n.t("fernieChat.attachmentTooLarge", { fileName, limit, ns: "common" });
};

const attachedContextLimit = {
	buildAttachedContextTooLargeMessage,
	isAttachedContextTooLong,
	MAX_ATTACHED_CONTEXT_LENGTH
};

export default attachedContextLimit;
